var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"headline"}},[_c('div',{staticClass:"CN"},[_vm._v(_vm._s(_vm.$t('headLine',{CNtitle: _vm.CNtitle,ENtitle: _vm.ENtitle})))]),_c('div',{staticClass:"line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }